<template>
  <div class="flex-column section" style="padding-top: 10px;">
    <el-form label-width="90px" label-position="left" style="padding-top: 5px;height: 100%;">
      <el-row>
        <el-radio-group v-model="pageRadio" class="spacing" no="1">
          <el-radio label="mblNo" style="float:left">{{ $t('SeaExport.BlNo') }}</el-radio>
          <el-radio label="jobNo" style="float:left">{{ $t('SeaExport.BusinessNo') }}</el-radio>
        </el-radio-group>

        <el-input v-model="inputString" style="width: 150px" class="spacing" no="2" />

        <el-button type="primary" no="3" @click="cloudFileUploadHandler">{{ $t('SeaExport.UploadFile') }}</el-button>
        <el-button type="primary" no="4" @click="queryHandler(false)">{{ $t('SeaExport.Query') }}</el-button>
        <el-button type="primary" no="5" @click="batchDownloadHandler">{{ $t('CargoMsg.Cargo_BatchDownload') }}</el-button>
        <el-button type="primary" no="6" @click="batchUploadHandler">{{ $t('CargoMsg.Cargo_BatchUpload') }}</el-button>
      </el-row>
      <el-row style="height: 100%;">
        <div class="section grid-wrapper" style="padding-top: 5px;height: 100%;">
          <cargo-ag-grid
            config-module="9400000"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :check-main-record="false"
            :deselect-main-record="false"
            style="width: 100%;flex:1;padding:10px;"
            @gridReady="onGridReady"
          />
        </div>
      </el-row>
    </el-form>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      ref="cargoCloudFileUpload"
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="lob"
      :upload-source="lob + 'BatchUploadFileChild'"
      :other-upload-func="otherUploadFunc"
      @uploadDone="data => {updateSop(data);refreshPage();}"
      @uploadDoneOtherProcessing="p => { getOcrFileHandler(p)}"
    />

    <!-- 批量上传文件弹框 -->
    <cargo-batch-file-upload
      ref="cargoBatchFileUpload"
      :visible.sync="batchCloudFile.visible"
      :job="batchCloudFile.job"
      :lob="batchCloudFile.lob"
      :batch-upload-data="batchCloudFile.batchUploadData"
      :upload-source="lob + 'BatchUploadFileChild'"
      :other-upload-func="batchOtherUploadFunc"
      @uploadDone="batchUpdateSop"
      @uploadDoneOtherProcessing="p => { getOcrFileHandler(p)}"
    />

    <!-- 文件详情-->
    <file-detail-form-window
      v-if="fileDetail.isShowingDetailForm"
      :visible="fileDetail.isShowingDetailForm"
      :row-data-file-detail="fileDetail.rowDataFileDetail"
      :show-detail-title="fileDetail.showDetailTitle"
      @onClose="detailClose"
    />

    <!-- 选择业务弹框 -->
    <job-list-window
      v-if="jobListWindow.visible"
      :visible.sync="jobListWindow.visible"
      :job-nos="jobListWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />

    <select-box-window
      v-if="selectBox.visible"
      :visible.sync="selectBox.visible"
      :lob="selectBox.lob"
      @selectBoxCloseHandler="selectBoxCloseHandler"
    />
  </div>
</template>

<script>
import fileDetailFormWindow from '@/components/Cargo/Job/uploadFile/fileDetailFormWindow'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import cargoBatchFileUpload from '@/components/Cargo/Common/cargoBatchFileUpload'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ServiceCodeDialog from '@/views/cargo/v0/SystemMaintenance/components/ServiceCodeDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import ColumnUtils from '@/utils/ColumnUtils'
import { getFileList } from '@/api/storage'
import { sortByMultiField } from '@/utils'
import { AgGridVue } from 'ag-grid-vue'
import { Job } from '@/class/model/booking/Job'
import { cache, cacheName } from '@/utils/cacheManager'
import { DocumentManage } from '@/utils/commonUtil'
import moment from 'moment'
import URL from '@/api/urlTranslator'
import { checkBsBalanceFunc, queryByNoOrMblFileFunc } from '@/api/booking/job'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import JobListWindow from '@/components/Cargo/Job/uploadFile/jobListWindow'
import SelectBoxWindow from '@/components/Cargo/Job/uploadFile/selectBoxWindow'
import { Project } from '@/class/model/pm/Project'
import { getLoading } from '@/utils/utilBaseElement'
import { updateTrackingForDocumentType, batchUpdateTrackingForDocumentType } from '@/api/fileHistory'
import { analyseFileFunc, batchCheckAnalyseFileFunc, checkAnalyseFileFunc } from '@/api/seaExport/intelligentBooking'
import { INTELLIGENT_DOCUMENT_SOURCE_9, INTELLIGENT_DOCUMENT_SOURCE_10 } from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BatchUploadFileChild',
  components: { SelectBoxWindow, cargoBatchFileUpload, JobListWindow, ServiceCodeDialog, fileDetailFormWindow, cargoCloudFileUpload, CargoAdvanceSelect, CargoButtonGroupSlider, AgGridVue },
  props: {
    lob: { type: String, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      gridApi: null,
      inputString: '',
      storageURL: '',
      docType: [],
      fileTypeMap: new Map(),
      user: {},
      job: {},
      pageRadio: 'mblNo',
      gridParams: {},
      documentManage: new DocumentManage(),
      rowData: [], // 列表中的数据
      rowDataList: [], // 临时处理中数据
      cloudFile: {
        visible: false,
        job: new Job()
      },
      batchCloudFile: {
        visible: false,
        job: new Project(),
        lob: this.lob,
        batchUploadData: {}
      },
      jobListWindow: {
        visible: false,
        jobs: []
      },
      selectBox: {
        visible: false,
        lob: this.lob
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      },
      fileDetail: {
        showDetailTitle: '',
        isShowingDetailForm: false,
        rowDataFileDetail: []
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        { headerName: this.$t('FileHistory.fileVersion'), field: 'fileVersion', width: 180, colId: 'fileVersion' },
        {
          headerName: this.$t('FileHistory.jobType'), field: 'fileType', width: 210, colId: 'fileType',
          cellRenderer: params => {
            return this.fileTypeLabelFunction(params.value)
          }
        },
        { headerName: this.$t('FileHistory.fileType'), field: 'fileFormat', width: 170, colId: 'fileFormat' },
        {
          headerName: this.$t('FileHistory.fileSize'), field: 'fileSize', width: 150, colId: 'fileSize',
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        },
        { headerName: this.$t('FileHistory.createdBy'), field: 'createdBy', width: 100, colId: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('FileHistory.createdDate'), field: 'createDate', width: 150, colId: 'createDate' },
        { headerName: this.$t('FileHistory.Details'), field: 'fileId', width: 150, colId: 'fileId',
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
            return `<a onclick="${methodPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.Details')}</a>`
          }
        },
        { headerName: this.$t('FileHistory.view'), field: 'fileId', width: 150, colId: 'fileId',
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
        }
      ]
    }
  },
  watch: {
  },
  created() {
    this.loading = null
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  mounted() {
    this.preloadBasicData()
    // 初始化文件类型
    this.getCategoryType()
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    fileTypeLabelFunction(value) {
      if (!value) return this.$t('Message.Other')
      let returnVal = ''
      const codes = value.split(',')
      for (let i = 0; i < codes.length; i++) {
        if (returnVal === '') {
          returnVal = this.fileTypeMap.get(codes[i]) || this.$t('Message.Other')
        } else {
          returnVal = returnVal + ',' + (this.fileTypeMap.get(codes[i]) || this.$t('Message.Other'))
        }
      }
      return returnVal
    },
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    async preloadBasicData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.configMap = cache.config
      this.storageURL = this.configMap.get('StorageURL')
    },
    async getCategoryType() {
      getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.lob }).then(res => {
        res.data.forEach(item => {
          if (item.type === 2) {
            this.fileTypeMap.set(item.code, this.isZh ? item.chineseName : item.englishName)
            this.docType.push(item)
          }
        })
      })
    },
    refreshPage(documentTypeUuid) {
      this.queryHandler(false)
    },
    updateSop(rowData) {
      // 提取documentTypeUuid
      let docKeys = ''
      if (rowData) {
        for (const item of rowData) {
          if (!item.documentTypeUuid) {
            continue
          }
          if (docKeys) {
            docKeys += ','
          }
          docKeys += item.documentTypeUuid
        }
      }
      const objParams = {
        jobUuid: this.cloudFile.job.uuid,
        docKeys
      }
      updateTrackingForDocumentType(objParams)
    },
    getOcrFileHandler(data) {
      if (data && data.row && data.row.length > 0) {
        const list = []
        for (const d of data.row) {
          const types = d.fileCategory.split(',')
          if (this.checkFileType(types)) {
            const rData = {}
            rData.fileId = d.fileId
            rData.fileName = d.fileName
            rData.fileSize = d.fileSize
            rData.iChannel = 3
            if (this.lob === 'AE') {
              rData.source = INTELLIGENT_DOCUMENT_SOURCE_10.code
            } else {
              rData.source = INTELLIGENT_DOCUMENT_SOURCE_9.code
            }
            if (d.jobList) {
              rData.jobUuidList = d.jobList.split(',')
            } else if (d.jobUuid || this.job.uuid) {
              const jobUuid = d.jobUuid || this.job.uuid
              rData.jobUuidList = [jobUuid]
            } else {
              continue
            }
            rData.pageSource = 'customsInfo'
            rData.officeId = this.$store.getters.currentOfficeId
            list.push(rData)
          }
        }
        if (list.length > 0) {
          analyseFileFunc(list)
        }
      }
    },
    batchUpdateSop(rowData) {
      const jobDocKeysObj = {}
      for (const row of rowData) {
        if (!row.jobUuid || !row.documentTypeUuid) {
          continue
        }
        let docKeys = jobDocKeysObj[row.jobUuid] || ''
        if (docKeys) {
          docKeys += ','
        }
        docKeys += row.documentTypeUuid
        jobDocKeysObj[row.jobUuid] = docKeys
      }
      if (Object.keys(jobDocKeysObj).length === 0) {
        return
      }
      batchUpdateTrackingForDocumentType(jobDocKeysObj)
    },
    batchDownloadHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }
      const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      const day = moment().format('YYYYMMDDHHmmss')
      const fileName = day + '.zip'
      window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.token}&fileIds=${fileIds}&fileName=${fileName}`)
    },
    // 批量上传
    batchUploadHandler() {
      this.selectBox.visible = true
    },
    // 文件上传
    cloudFileUploadHandler() {
      this.queryHandler(true)
    },
    // 列表查询
    queryHandler(isUpload) {
      const t = this.inputString
      // 初始化参数
      this.params = {}
      this.cloudFile.job = new Job()
      if (this.pageRadio === 'mblNo') {
        if (!t || !t.trim()) {
          this.$message.warning(this.$t('queryJob.enterBillOfLadingNumber'))
          return
        }
        this.params.mblNo = t
        this.params.branchId = 0
        this.params.lob = this.lob
      } else if (this.pageRadio === 'jobNo') {
        if (!t || !t.trim()) {
          this.$message.warning(this.$t('Message.PleaseEnterTheBusinessNumber'))
          return
        }
        this.params.jobNo = t
        this.params.branchId = this.$store.getters.currentOfficeId
        this.params.lob = this.lob
      }
      this.loading = getLoading()
      // 根据业务编号 或者 提单号查询业务
      queryByNoOrMblFileFunc(this.params).then(res => {
        const list = []
        if (res.data && res.data.length > 0) {
          if (isUpload) {
            // 处理上传文件
            this.uploadHandler(res.data)
          } else {
            this.rowData = []
            if (res.data.length === 1) {
              list.push(this.toQuery(res.data[0]))
            } else {
              for (let i = 0; i < res.data.length; i++) {
                const j = res.data[i]
                list.push(this.toQuery(j))
              }
            }
            Promise.all(list).then(res => {
              const list = []
              for (let i = 0; i < res.length; i++) {
                const l = res[i]
                for (let ii = 0; ii < l.length; ii++) {
                  list.push(l[ii])
                }
              }
              this.rowData = list
              this.getFilesSucceedHandler()
            })
          }
        } else {
          const text = this.pageRadio === 'mblNo' ? this.$t('SeaExport.BlNo') : this.$t('Payment.businessNumber')
          this.$message.warning(text + this.$t('Message.NonExistent'))
        }
      }).catch((err) => {
        this.loading.close()
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    uploadHandler(jobList) {
      if (!jobList) {
        return
      }
      if (jobList.length === 1) {
        const j = jobList[0]
        this.doUploadFile(j)
      } else {
        // 多个业务，弹框选一下
        this.jobListWindow.jobs = jobList
        this.jobListWindow.visible = true
      }
    },
    // 选择后的业务 继续文件上传
    selectJobNoHandler(data) {
      this.doUploadFile(data)
    },
    doUploadFile(data) {
      if (data) {
        this.job = data
        this.cloudFile.job.lob = data.lob
        this.cloudFile.job.uuid = data.uuid
        this.cloudFile.job.jobNo = data.jobNo
        this.cloudFile.job.mbl = data.mblNo
        this.cloudFile.visible = true
      }
    },
    // 查询文件
    toQuery: function(data) {
      const result = []
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>jobNo</key><value>' +
              data.jobNo +
        '</value></entry></extendMetaData></data></RequestObject>'
      return new Promise((resolve) => {
        getFileList(xmlParam).then(res => {
          const l = Array.from(res.data, p => {
            return {
              fileId: p.id,
              fileName: p.fileName,
              fileType: p.extendMetaData.documentType || '',
              fileFormat: p.fileType.split(';')[0],
              fileSize: p.fileSize,
              fileVersion: Number(p.fileVersion),
              createDate: p.createDate,
              createChineseName: p.extendMetaData.createChineseName || '',
              createdBy: p.extendMetaData.createdBy,
              extendMetaData: p.extendMetaData,
              fileNameBak: p.fileName,
              path: '',
              hasParent: false,
              parentId: ''

            }
          })
          for (let i = 0; i < l.length; i++) {
            result.push(l[i])
          }
          resolve(result)
        })
      })
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      // 排序后放入临时对象数据
      const rowDataTempt = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!rowDataTempt || rowDataTempt.length === 0) {
        return
      }
      let fatherFile = rowDataTempt[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      fatherFile.hasParent = false
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < rowDataTempt.length; i++) {
        childFile = rowDataTempt[i]
        childFile.hasParent = false
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.parentId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      // 数据组装后 父级再次排序 根据createDate fileName
      let parentFileList = source.filter(val => {
        return val.hasParent === false
      })
      const childFileList = source.filter(val => {
        return val.hasParent === true
      })
      parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

      const fileList = [...parentFileList, ...childFileList]

      this.rowData = fileList
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.fileDetail.isShowingDetailForm = true
      const fileObject = this.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.fileDetail.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent']

      var docTypeFilter = null
      var documentType = ''
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        documentType = extendMetaData.documentType
        if (documentType === this.$t('Message.Other')) {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (var key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        var keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t('SeaExport.Accessible') : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        var keyName
        keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = this.$t('SeaExport.BookingAgent')
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.fileDetail.rowDataFileDetail = tempFileDetailList
    },
    doFunc(func, check) {
      if (func && check) {
        func(true)
      } else if (func) {
        func()
      }
    },
    batchOtherUploadFunc(func) {
      // 开启报关单识别参数
      const open = String(cache.config.get('openCustomsDeclarationRecognition')) === '1'
      if (open && (this.lob === 'SE' || this.lob === 'AE')) {
        // 校验下计费系统
        const rows = this.$refs.cargoBatchFileUpload.rowData.filter(p => !p.fileId)
        if (rows.length === 0) {
          return
        }
        const fileNameList = []
        for (const data of rows) {
          const types = data.fileCategory.split(',')
          if (this.checkFileType(types)) {
            if (!fileNameList.includes(data.fileName)) {
              fileNameList.push(data.fileName)
            } else {
              data.duplicate = 1
            }
          }
        }
        if (fileNameList.length > 0) {
          this.batchCheckFileDuplicate(func, rows, fileNameList)
        } else {
          this.checkBill(func, rows)
        }
      } else {
        this.doFunc(func)
      }
    },
    checkFileType(types) {
      return (types.includes('declarations') || types.includes('customDeclarationNote') || types.includes('CUSTOMDECLARATIONNOTE'))
    },
    otherUploadFunc(func) {
      // 开启报关单识别参数
      const open = String(cache.config.get('openCustomsDeclarationRecognition')) === '1'
      if (open && (this.lob === 'SE' || this.lob === 'AE')) {
        // 校验下计费系统
        const rows = this.$refs.cargoCloudFileUpload.rowData.filter(p => !p.fileId)
        if (rows.length === 0) {
          return
        }
        const fileNameList = []
        for (const data of rows) {
          const types = data.fileCategory.split(',')
          if (this.checkFileType(types)) {
            if (!fileNameList.includes(data.fileName)) {
              fileNameList.push(data.fileName)
            } else {
              data.duplicate = 1
            }
          }
        }
        if (fileNameList.length > 0) {
          this.checkFileDuplicate(func, rows, fileNameList)
        } else {
          this.checkBill(func, rows)
        }
      } else {
        this.doFunc(func)
      }
    },
    checkFileDuplicate(func, rows, fileNameList) {
      const data = {
        fileNameList: fileNameList,
        pageRadio: this.pageRadio,
        mblNo: this.params.mblNo,
        jobNo: this.params.jobNo
      }
      checkAnalyseFileFunc(data).then(res => {
        const fileNames = res.data
        if (fileNames && fileNames.length > 0) {
          for (const row of rows) {
            const types = row.fileCategory.split(',')
            if (fileNames.includes(row.fileName) && this.checkFileType(types)) {
              row.duplicate = 1
            }
          }
        }
        this.checkBill(func, rows)
      })
    },
    batchCheckFileDuplicate(func, rows, fileNameList) {
      const data = {
        fileNameList: fileNameList,
        pageRadio: this.pageRadio,
        mblNo: this.batchCloudFile.batchUploadData.isMbl,
        jobNo: this.batchCloudFile.batchUploadData.isJobNo
      }
      batchCheckAnalyseFileFunc(data).then(res => {
        const fileNames = res.data
        if (fileNames && fileNames.length > 0) {
          for (const row of rows) {
            const types = row.fileCategory.split(',')
            if (fileNames.includes(row.fileName) && this.checkFileType(types)) {
              row.duplicate = 1
            }
          }
        }
        this.checkBill(func, rows)
      })
    },
    checkBill(func, rows) {
      let num = 0
      for (const data of rows) {
        const types = data.fileCategory.split(',')
        if (this.checkFileType(types)) {
          num++
        }
      }
      if (num > 0) {
        // 计费系统校验
        checkBsBalanceFunc(SystemConstants.TYPE_CUSTOMS_ANALYSIS, num).then(res => {
          if (res.data && res.data === 'lowBalance') {
            this.$confirm(this.$t('Message.lowBalanceTips'), this.$t('Message.WarmReminder'), {
              confirmButtonText: this.$t('Message.lowBalanceTips1'),
              cancelButtonText: this.$t('Message.lowBalanceTips2'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => {
              this.doFunc(func)
            })
          } else if (res.data === 'ok') {
            // 报关单解析
            this.doFunc(func, true)
          } else {
            // 正常上传
            this.doFunc(func)
          }
        })
      } else {
        this.doFunc(func)
      }
    },
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.$store.getters.userInfo.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.user.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (!result || result.length === 0) {
        return true
      }

      if (this.user.admin || parseInt(data.createdBy) === this.user.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.warning(this.$t('SeaExport.FileNotAllowedView').replace('{0}', data.fileName))
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToView').replace('{0}', data.fileName))
        return
      }
      return true
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    objKeySort(obj) {
      var newkey = Object.keys(obj).sort()
      var newObj = {}
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]]
      }
      return newObj
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (var i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }
      return false
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      var convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
      }
      return convertKeyName
    },
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      var codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        const docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    detailClose() {
      this.fileDetail.isShowingDetailForm = false
    },
    selectBoxCloseHandler(data) {
      this.selectBox.visible = false
      if (data) {
        this.batchCloudFile = data
      }
    }
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
.spacing {
  padding-right: 10px;
}

.row-constant span {
  color: #67c23a;
}

</style>
